import Link from "../../components/Link";

const Crumb = ({ crumb }) => {
  if (crumb?.url == null)
    return <p style={{ padding: "0 var(--spacing-1)" }}>{crumb?.label}</p>;
  return <Link to={crumb?.url}>{crumb?.label}</Link>;
};

export default Crumb;
